import backofficeService from '../../api/backoffice'

export default {
  /**
   * Get list of categories
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to categories
   */
  getSavedStudentReport(params) {
    return backofficeService.Api().get(`classRoom/report-card/student/list`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },


}
